import { ISearchFilterLicenceRequest } from 'models/searchFilter';
import { clearObject } from 'helpers/objects';
import { ISearchFormValues } from 'models/licence';
import { isMatch, isValid, parse } from 'date-fns';
import { formatOnlyDateToRequest } from 'utils/date';

const mapFilterDateToRequest = (
  date: string | Date | null | undefined,
  shortDateFormat: string,
): string | null => {
  if (!date) {
    return null;
  }

  const parsedDate =
    typeof date === 'string' && isMatch(date, shortDateFormat)
      ? parse(date, shortDateFormat, new Date())
      : new Date(date);

  return isValid(parsedDate) ? formatOnlyDateToRequest(parsedDate) : null;
};

export const mapValuesToLicencePresetRequest = (
  data: ISearchFormValues,
  shortDateFormat: string,
): ISearchFilterLicenceRequest => {
  const values: ISearchFilterLicenceRequest = {
    weaponLicenceNumber: data.weaponLicenceNumber,
    weaponLicenceName: data.weaponLicenceName,
    legalName: data.legalName,
    legalTypeUniqueId: data.legalTypeUniqueId,
    statusesUniqueIds: data.statusesUniqueIds,
    licenceAuthorityUniqueIds: data.licenceAuthorityUniqueIds,
    expiryDateFrom: mapFilterDateToRequest(data.expiryDateFrom, shortDateFormat),
    expiryDateTo: mapFilterDateToRequest(data.expiryDateTo, shortDateFormat),
  };
  return clearObject(values);
};
